import { NavigationOpen } from '@energy-retailer/icons';
import clsx from 'clsx';
import Link from 'next/link';

import { Text } from '@/components/text';

import type { PlanListItemProps } from './plan-list.types';

const PlanListItem = ({
  url,
  distributor,
  tariffType,
  planID,
  planName,
}: PlanListItemProps) => {
  return (
    <div role="listitem">
      <Link
        className="button text group/plan-list grid grid-cols-1 items-center gap-b rounded-rad-a border-none p-d text-left outline-none ring-1 ring-inset ring-gray-700 transition-all hover:no-underline hover:ring-2 hover:ring-blue-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-pink-500 active:ring-2 active:ring-blue-600 md:grid-cols-4 md:p-b"
        href={url}
        target="_blank"
      >
        <span
          className={clsx([
            !tariffType && 'md:col-span-2',
            'col-span-1 flex items-center justify-between',
          ])}
        >
          <Text
            variant="h4"
            as="span"
            className="col-span-1 transition-colors group-hover/plan-list:text-blue-500 group-active/plan-list:text-blue-600"
          >
            {planName}
          </Text>
          <NavigationOpen className="h-icon w-icon text-blue md:hidden" />
        </span>
        {tariffType ? (
          <Text
            variant="body3"
            as="span"
            className="col-span-1"
          >
            {tariffType}
          </Text>
        ) : null}
        <Text
          variant="body3"
          as="span"
          className="col-span-1"
        >
          {distributor.name}
        </Text>
        <span className="col-span-1 flex items-center justify-between">
          <Text
            variant="body3"
            as="span"
          >
            {planID}
          </Text>
          <NavigationOpen className="-mt-1.5 hidden h-icon w-icon text-blue md:block" />
        </span>

        <span className="sr-only">(opens in a new window)</span>
      </Link>
    </div>
  );
};

export default PlanListItem;
